import React, { ReactElement, CSSProperties } from 'react'
import { TextKey } from '../../../pure-js/types/Antiloop'
import { getGrooverText } from '../libs/GrooverTextRepository'
import { getTextStyle } from '../libs/TextRepository'
import { Skeleton } from '@mui/material'

/**
 * @deprecated Use GrooverText component instead
 */
export type FigmaTextProps = {
  textKey?: TextKey | string
  styleTextKey?: TextKey | string
  className?: string
  text?: string
  onClick?: () => unknown
  link?: boolean
  anchorHref?: string
  textTransform?: 'uppercase'
  separator?: ReactElement
  separatorWhenEmptyContent?: ReactElement
  lineHeight?: number
  language?: 'en' | 'sv'
}

/**
 * @deprecated Use GrooverText component instead
 */
const FigmaText = (props: React.PropsWithChildren<FigmaTextProps>) => {
  const { text: _text, styleTextKey, textKey, className, link, anchorHref, textTransform, language } = props

  // Get style from new design system or legacy format
  let style: CSSProperties | undefined = undefined
  if (styleTextKey) {
    style = typeof styleTextKey === 'string' ? getTextStyle(styleTextKey) : styleTextKey.style
  } else if (textKey) {
    style = typeof textKey === 'string' ? getTextStyle(textKey) : textKey.style
  }

  if (!style) return null
  style = mapStyle(style, link || false)

  // Get text from new compact system or legacy format
  let text = ''
  if (typeof _text === 'string') {
    text = _text
  } else if (textKey) {
    text = typeof textKey === 'string' ? getGrooverText(textKey, language) : getGrooverText(textKey, language)
  }

  if (textTransform === 'uppercase') text = text.toUpperCase()

  if (anchorHref)
    return (
      <a href={anchorHref} style={style} dangerouslySetInnerHTML={{ __html: text }} target="_blank" rel="noreferrer" />
    )

  return <span dangerouslySetInnerHTML={{ __html: text }} className={className} style={style} />
}

/**
 * @deprecated Use GrooverText component instead
 */
export type FigmaTextOrSkeletonProps = FigmaTextProps & {
  isLoading?: boolean
}

/**
 * @deprecated Use GrooverText component instead
 */
export const FigmaTextOrSkeleton = (props: FigmaTextOrSkeletonProps) => {
  const { isLoading, ...rest } = props
  if (isLoading) {
    return (
      <SkeletonCustom>
        <FigmaText {...rest} />
      </SkeletonCustom>
    )
  }
  return <FigmaText {...rest} />
}

export const SkeletonCustom = ({ children }: { children: React.ReactNode }) => {
  return (
    <Skeleton
      animation="wave"
      sx={{
        '&::after': {
          animationDuration: '1s',
          background: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.2), transparent)'
        }
      }}
    >
      {children}
    </Skeleton>
  )
}

const mapStyle = (style: CSSProperties, link: boolean): CSSProperties => {
  if (link) return { ...style, textDecoration: 'underline', cursor: 'pointer' }
  return style
}

/**
 * @deprecated Use GrooverText component instead
 */
export default FigmaText
